import { ExpansionCardIcon } from './ExpansionCardIcon';

/**
 * author: GreenTurtwig
 * id 6FFC7116-2E5B-40A8-A612-90706DC5EECF
 * name expansion-card
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/expansion-card.svg
 * tags
 * - Gaming / RPG 
 */
export const GraphicsProcessingUnitIcon = ExpansionCardIcon;
export default GraphicsProcessingUnitIcon